import { getApi } from '../utils/api';
import { logError } from '../utils/logger';
import { API_ENDPOINTS } from '../utils/endpoints';

export const storeService = {
  /**
   * Fetches stores associated with the current user
   * @returns {Promise<Array>} List of stores
   */
  getStores: async () => {
    try {
      const api = getApi();
      const response = await api.get(API_ENDPOINTS.STORES.LIST);
      if (!response.data) {
        throw new Error('No data received from stores API');
      }
      return response.data;
    } catch (error) {
      logError(error, 'storeService.getStores');
      throw error;
    }
  },

  /**
   * Fetches details for a specific store
   * @param {string} storeId - ID of the store to fetch
   * @returns {Promise<Object>} Store details
   */
  getStoreDetails: async (storeId) => {
    try {
      console.log('Fetching store details for ID:', storeId);
      console.log('Using endpoint:', API_ENDPOINTS.STORES.DETAILS(storeId));
      
      const api = getApi();
      const response = await api.get(API_ENDPOINTS.STORES.DETAILS(storeId));
      console.log('Store details API response:', response);
      
      if (!response.data) {
        console.error('No data in store details response');
        return null;
      }
      
      return response.data;
    } catch (error) {
      console.error('Error fetching store details:', error);
      logError(error, 'storeService.getStoreDetails', { storeId });
      return null;
    }
  }
};
